import { render, staticRenderFns } from "./envirenmental.vue?vue&type=template&id=783cbcd4&scoped=true&"
import script from "./envirenmental.vue?vue&type=script&lang=js&"
export * from "./envirenmental.vue?vue&type=script&lang=js&"
import style0 from "./envirenmental.vue?vue&type=style&index=0&id=783cbcd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783cbcd4",
  null
  
)

export default component.exports